<app-page-layout
  [title]="title"
  [subtitle]="subtitle"
  [heroImage]="heroImage"
  [breadcrumbs]="breadcrumbs">

  <section class="not-found">
    <div class="container">
      <p class="lead">
        La page que vous cherchez est introuvable. Elle a peut-être été renommée,
        ou l'adresse comporte une erreur.
      </p>

      <h2>Nos principales garanties</h2>
      <ul class="suggestions">
        <li *ngFor="let s of suggestions">
          <a [routerLink]="s.link">{{ s.label }}</a>
        </li>
      </ul>

      <a routerLink="/" class="back-home">Retour à l'accueil</a>
    </div>
  </section>

</app-page-layout>
